import { Box, ColorPicker as ColorPicker$1 } from '@wix/design-system';
import t__default, { useState } from 'react';
import { ColorSwatches } from '../common/color-swatches.js';
import '../../RevertSmall-778c3822.js';
import 'classnames';
import 'ricos-context';
import '../../style-inject.es-e7b07dd7.js';
import '../common/data-hooks.js';

const ColorPicker = ({
  userColors,
  color,
  onChange,
  onNewColorAdded,
  showColorPicker: initialShowColorPicker,
  colorPickerClassName,
  showResetButton
}) => {
  const [showColorPicker, setShowColorPicker] = useState(initialShowColorPicker);
  return /* @__PURE__ */ t__default.createElement(Box, { direction: "vertical", marginTop: "SP2", marginBottom: "SP2", gap: "SP2" }, /* @__PURE__ */ t__default.createElement(
    ColorSwatches,
    {
      userColors,
      selectedColor: color,
      onAddClick: () => setShowColorPicker(true),
      onChange,
      showResetButton
    }
  ), showColorPicker ? /* @__PURE__ */ t__default.createElement("div", { className: colorPickerClassName }, /* @__PURE__ */ t__default.createElement(
    ColorPicker$1,
    {
      value: color || userColors[0],
      showConverter: false,
      onChange: () => {
      },
      onConfirm: (color2) => {
        setShowColorPicker(false);
        const colorHex = typeof color2 === "string" ? color2 : color2.hex();
        if (!userColors.includes(colorHex)) {
          onNewColorAdded(colorHex);
        }
      },
      onCancel: () => setShowColorPicker(false)
    }
  )) : null);
};

export { ColorPicker };
//# sourceMappingURL=color-picker.js.map
